var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.66667 6.33333V3M13.3333 6.33333V3M5.83333 9.66667H14.1667M4.16667 18H15.8333C16.2754 18 16.6993 17.8244 17.0118 17.5118C17.3244 17.1993 17.5 16.7754 17.5 16.3333V6.33333C17.5 5.89131 17.3244 5.46738 17.0118 5.15482C16.6993 4.84226 16.2754 4.66667 15.8333 4.66667H4.16667C3.72464 4.66667 3.30072 4.84226 2.98816 5.15482C2.67559 5.46738 2.5 5.89131 2.5 6.33333V16.3333C2.5 16.7754 2.67559 17.1993 2.98816 17.5118C3.30072 17.8244 3.72464 18 4.16667 18Z",
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.ddc46cd1.svg";
export { ForwardRef as ReactComponent };